import React, { Component } from 'react';
import { Table,Tabs,Button,Pagination,Input, Row, Col,Select,Modal,Form,DatePicker,message,Radio, Breadcrumb,Tag} from 'antd';
import * as action from './action.js';
import { connect } from 'react-redux';
import '@/css/image_correction.less'


import {getImageCorrectionTaskListAPI,modifyTaskStatusAPI} from '@/API'
import {tabList,tableColumns} from './constData'
import {WrappedCreateTaskForm} from './modal/create_task'
import {WrappedAssignStaffForm} from './modal/assign_staff'
import {WrappedExportTaskStatsForm} from './modal/export_task_stats'

const Search = Input.Search,
	  Option = Select.Option,
	  confirm = Modal.confirm,
	  FormItem = Form.Item,
	  TabPane = Tabs.TabPane,
	  RadioGroup = Radio.Group;


export class ImageCorrectionList extends Component{

    state={
       listQuery:{
       		sign_user:undefined,//标记人
       		icon_user:undefined,//插画师
       		icon_leader:undefined,//插画组长
       		icon_check_user:undefined,//插画师审核人
       		sign_check_user:undefined,//题目审核人
       		task_id:undefined,
       		check_user:undefined,
       		search:'',//任务名
       		stage_type:'',//tab任务状态
       		page:1,
       		pagesize:20,
       },
       taskList:[],
       total:0,
       loading:false,
       openCreate:false,
       openAssign:false,
       openExport:false,
       assignType:'',//分配modal类型
       selectedRowKeys:[],

    }

    componentDidMount(){
    	  this.props.getMemberList()
    	  
     
    }
    componentWillReceiveProps(){
    		this.setDefalutTab()
    }
    //todo 设置默认tab
    setDefalutTab=()=>{
    	    let listQuery=this.state.listQuery
		if(this.props.user.role_icon){
			let authList=this.props.user.role_icon.columns
			tabList.some((v,i)=>{
				return authList[i].some((n)=>{
					listQuery.stage_type=v.key
					return n==1
				})
			})
			this.setState({listQuery},()=>{
				this.getImageCorrectionTaskList()
			})
			
		}
    }

    handleFilterChange(value,type){
    		let listQuery=this.state.listQuery
    		listQuery[type]=value
    		this.setState({listQuery})
    }

    getImageCorrectionTaskList=()=>{
    		this.setState({
    			loading:true,
    			taskList:[],
    			selectedRowKeys:[],
    		})
    		getImageCorrectionTaskListAPI(this.state.listQuery).then(res=>{
    				let data=res.data
    				this.setState({
    					taskList:data.list,
    					total:data.total,
    					loading:false
    				})
    				
    		}).catch(e=>{
    			this.setState({
	    			loading:false
	    		})
    		})
    }
    handleSearch=()=>{
    		this.getImageCorrectionTaskList()
    }
    handleReset=()=>{
    		let listQuery={
       		sign_user:undefined,//标记人
       		icon_user:undefined,//插画师
       		icon_leader:undefined,//插画组长
       		icon_check_user:undefined,//插画师审核人
       		sign_check_user:undefined,//题目审核人
       		task_id:undefined,
       		check_user:undefined,
       		search:'',//任务名
       		page:1,
       		pagesize:20,
       }
    	   this.setState({listQuery},()=>{
    	   		this.getImageCorrectionTaskList()
    	   })
    	   
    }
   
    renderFilter(){
    		const formItemLayout = {
	      labelCol: { span: 10 },
	      wrapperCol: { span: 14 },
	    };
	   
	    let { sign_user_list,icon_user_list,icon_leader_list,icon_check_user_list,check_user_list}=this.props.memberList

		const markManOptions = sign_user_list.map(v => <Option value={v.id}  key={v.id}>{v.username}</Option>);
	    	const illustratorOptions = icon_user_list.map(v => <Option value={v.id} key={v.id}>{v.username}</Option>);
	    	const groupLeaderOptions = icon_leader_list.map(v => <Option value={v.id} key={v.id}>{v.username}</Option>);
	    const picVerifierOptions = icon_check_user_list.map(v => <Option value={v.id} key={v.id}>{v.username}</Option>);
	    const exerciseVerifierOptions = check_user_list.map(v => <Option value={v.id} key={v.id}>{v.username}</Option>);
	    const filterList=[{
			label:'标记人',
			key:'sign_user',
			options:markManOptions
		},{
			label:'插画师',
			key:'icon_user',
			options:illustratorOptions
		},
		{
			label:'插画组长',
			key:'icon_leader',
			options:groupLeaderOptions
		},{
			label:'插画审核人',
			key:'icon_check_user',
			options:picVerifierOptions
		},{
			label:'题目审核人',
			key:'check_user',
			options:exerciseVerifierOptions
		}]

    		return(
    			 <Form
		      >
		        <Row gutter={40}>
		        		{
		        			filterList.map((v,i)=>{
		        				return(
		        					<Col key={i} span={6}> 
					       			<FormItem {...formItemLayout} label={v.label}>
					       			<Select
					       				showSearch
								        value={this.state.listQuery[v.key]}
								        defaultActiveFirstOption={false}
								        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
								        onChange={(value)=>this.handleFilterChange(value,v.key)}
								      >
					       				{v.options}
					       			 </Select>
					       			</FormItem>
					       		</Col>
		        				)
		        			})
		        		}
		        		<Col span={6}> 
		        		<FormItem {...formItemLayout} label="任务ID">
			        		<Input
			        			value={this.state.listQuery.task_id}
						    onChange={e =>this.handleFilterChange(e.target.value,'task_id')}
						  />
		        		</FormItem>
		        		</Col>
		        		<Col span={6}> 
		        		<FormItem {...formItemLayout} label="任务名称">
			        		<Input
			        			value={this.state.listQuery.search}
						    onChange={e =>this.handleFilterChange(e.target.value,'search')}
						  />
		        		</FormItem>
		        		</Col>
		        </Row>
		        <Row>
		          <Col span={24} style={{ textAlign: 'right' }}>
		            <Button type="primary" onClick={this.handleSearch}>查询</Button>
		            <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>清空</Button>
		          </Col>
		        </Row>
		      </Form>
    		)
    }
    tabChange=(value)=>{
    		let  {listQuery}=this.state
    		listQuery.stage_type=value
    		listQuery.page=1
    		this.setState({listQuery})
    		this.getImageCorrectionTaskList()
    }
    onPageChange=(val)=>{
    		let {listQuery}=this.state
    		listQuery.page=val
    		this.setState({listQuery})
    		this.getImageCorrectionTaskList()
    }
    handleOpenModal(openKey){
    		this.setState({[openKey]:true})
    }
    handleOpenAssign(assignType){
    		this.setState({openAssign:true,assignType})
    }
    //各状态提交、返工、删除合并
    handleConfirmModifyStatus(modifyType){
    		//todo stage modifytype  
    		let messageMapList={
    			submit:'确认提交选中任务吗？',
    			rework:'确认将选中任务返工吗？',
    			delete:'确认删除选中任务吗？',
    		}
    		let self=this
    		confirm({
		    title: messageMapList[modifyType],
		    onOk() {
		      	self.modifyTaskStatus(modifyType)
		    }
		  });
    		
    }
    modifyTaskStatus(modifyType){
    		let {stage_type}=this.state.listQuery
    		let params={task_id:this.state.selectedRowKeys}
    		modifyTaskStatusAPI(stage_type,modifyType,params).then(res=>{
    			message.success('操作成功！')
    			this.getImageCorrectionTaskList()
    		})
    }

    handleClose=(closeType)=>{
    		this.setState({openCreate:false,openAssign:false,openExport:false})
    		closeType=='update'?this.getImageCorrectionTaskList():null
    }

    
    onSelectChange = (selectedRowKeys) => {
	    this.setState({ selectedRowKeys });
	}
	renderTab(){
		let {stage_type}=this.state.listQuery
		
		let {selectedRowKeys}=this.state
		const hasSelected = selectedRowKeys.length > 0;
		//按钮权限
		let btnAuth={}
		//tab权限
		if(this.props.user.role_icon){
			let authList=this.props.user.role_icon.columns
			btnAuth=this.props.user.role_icon.buttons
			tabList.map((v,i)=>{
				authList[i].every((n)=>{
					return n==0
				})?v.hidden=true:v.hidden=false
				return v
			})
		}
		//btn可用，由state_type和权限共同决定
		
		 let  createTaskAble=['signing'].includes(stage_type)&&btnAuth.addTask,//创建任务
			  assignMarkerAble=['signing'].includes(stage_type)&&btnAuth.assignSignUser,//分配标记员
			  submitTaskAble=['signing','sign_checking','sign_rework','icon_checking','icon_rework','checking','icon_ing'].includes(stage_type),//提交任务
			  deleteTaskAble=['signing'].includes(stage_type)&&btnAuth.del,//删除任务
			  assignMarkVerifierAble=['sign_checking'].includes(stage_type)&&btnAuth.assignSignCheckUser,//分配标记审核员
			  reworkAble=['sign_checking','icon_checking','checking'].includes(stage_type),//返工
			  assignPicAndVerifierAble=['sign_check_pass'].includes(stage_type)&&btnAuth.assignIconUser,//分配插画师和插画审核员
			  assignIllustratorAble=['icon_ing'].includes(stage_type)&&btnAuth.assignIconIconUser,//分配插画师
			  assignPicVerifierAble=['icon_checking'].includes(stage_type)&&btnAuth.assignIconCheckUser,//分配插画审核员
			  assignExerciseVerifierAble=['icon_check_pass','checking'].includes(stage_type)&&btnAuth.assignCheckUser//分配题目审核员
		//btn权限部分
		switch (stage_type){
			case 'signing':
				submitTaskAble=submitTaskAble&&btnAuth.signSubmit
				break;
			case 'sign_checking':
				submitTaskAble=submitTaskAble&&btnAuth.taskSignCheckPass
				reworkAble=reworkAble&&btnAuth.taskSignRework
				break;
			case 'sign_rework':
				submitTaskAble=submitTaskAble&&btnAuth.taskSignModifySubmit
				break;
			case 'icon_ing':
				submitTaskAble=submitTaskAble&&btnAuth.iconSubmit
				break;
			case 'icon_checking':
				submitTaskAble=submitTaskAble&&btnAuth.taskIconCheckPass
				reworkAble=reworkAble&&btnAuth.taskIconRework
				break;
			case 'icon_rework':
				submitTaskAble=submitTaskAble&&btnAuth.taskIconModifySubmit
				break;
			case 'checking':
				submitTaskAble=submitTaskAble&&btnAuth.taskCheckPass
				reworkAble=reworkAble&&btnAuth.taskRework
				break;
			default:
				break;
		}
  
		let tabPane=tabList.map(v=>{
			if(!v.hidden){
				return(
					<TabPane tab={v.name} key={v.key}></TabPane>
				)
			}
			
		})
		return(
			<div id="imageCorrectionTab">
				<Tabs   type="card" activeKey={stage_type} onChange={this.tabChange}>
			    		{tabPane}
				</Tabs>
				<div>

					{!!createTaskAble&&<Button className="funcBtn" onClick={()=>this.handleOpenModal('openCreate')}>创建任务</Button>}
					{!!assignMarkerAble&&<Button  disabled={!hasSelected} className="funcBtn" onClick={()=>this.handleOpenAssign('sign_user')}>分配标记员</Button>}
					{!!submitTaskAble&&<Button  disabled={!hasSelected} className="funcBtn" onClick={()=>this.handleConfirmModifyStatus('submit')}>提交任务</Button>}
					{!!deleteTaskAble&&<Button  disabled={!hasSelected} className="funcBtn" onClick={()=>this.handleConfirmModifyStatus('delete')}>删除任务</Button>}
					{!!assignMarkVerifierAble&&<Button  disabled={!hasSelected} className="funcBtn" onClick={()=>this.handleOpenAssign('sign_check_user')}>分配标记审核员</Button>}
					{!!reworkAble&&<Button  disabled={!hasSelected} className="funcBtn" onClick={()=>this.handleConfirmModifyStatus('rework')}>返工</Button>}
					{!!assignPicAndVerifierAble&&<Button  disabled={!hasSelected} className="funcBtn" onClick={()=>this.handleOpenAssign('icon_and_check_user')}>分配插画师&插画审核员</Button>}
					{!!assignIllustratorAble&&<Button  disabled={!hasSelected} className="funcBtn" onClick={()=>this.handleOpenAssign('icon_user')}>分配插画师</Button>}
					{!!assignPicVerifierAble&&<Button  disabled={!hasSelected} className="funcBtn" onClick={()=>this.handleOpenAssign('icon_check_user')}>分配插画审核员</Button>}
					{!!assignExerciseVerifierAble&&<Button  disabled={!hasSelected} className="funcBtn" onClick={()=>this.handleOpenAssign('check_user')}>分配题目审核员</Button>}
					{stage_type=='finish'&&!!btnAuth.taskStatistics&&<div style={{textAlign:'right'}}><Button   type='primary' className="funcBtn" onClick={()=>this.handleOpenModal('openExport')}>任务统计导出</Button></div>}

					{hasSelected&&<span style={{ marginLeft: 8,fontSize:'12px' }}>
			            <Tag color="orange">已勾选{selectedRowKeys.length}条</Tag>
			        </span>}
				</div>
			</div>
		)
		
	}
	
	renderTable(){
		let columns=tableColumns
		let data=this.state.taskList
		let tabIndex=0
		let {selectedRowKeys}=this.state
		const rowSelection = {
	      selectedRowKeys,
	      onChange: this.onSelectChange,
	    };
	    
		//选中tab index
		tabList.forEach(v=>{
			if(v.key==this.state.listQuery.stage_type){
				tabIndex=v.index
			}
		})

		//table columns权限
		if(this.props.user.role_icon){
			let authList=this.props.user.role_icon.columns
			columns=columns.filter((v,i)=>{
				if(authList[tabIndex][i]){
					return true
				}else{
					return false;
				}
			})
		}
		
		return(
			<Table scroll={{ x: 1500 }} rowSelection={rowSelection} loading={this.state.loading} rowKey={record=>record.task_id} pagination={false} columns={columns} dataSource={data} />
		)
	}
    render(){
		let {total,openCreate,openAssign,openExport,selectedRowKeys,assignType}=this.state
		let {memberList}=this.props
		if(memberList){
			return(
	            <div id="imageCorrection">
	                <Breadcrumb className="breadCrumb">
	                    <Breadcrumb.Item  className="breadItem" ><span>题目管理</span></Breadcrumb.Item>
	                    <Breadcrumb.Item className="breadItem"><span>图片订正</span></Breadcrumb.Item> 
	                </Breadcrumb>  
	                 <div>
	                 	{this.renderFilter()}
	                 	{this.renderTab()}
	                 	{this.renderTable()}
	                 	<div style={{textAlign:'right',margin:'20px'}}><Pagination showQuickJumper defaultCurrent={1} total={total} onChange={this.onPageChange} /></div>
	                 </div>
	                 <WrappedCreateTaskForm openCreate={openCreate} handleClose={this.handleClose} memberList={memberList}/>
	                 <WrappedAssignStaffForm openAssign={openAssign} assignType={assignType} handleClose={this.handleClose} memberList={memberList} taskId={selectedRowKeys}/>
	                 <WrappedExportTaskStatsForm openExport={openExport} handleClose={this.handleClose} />
	            </div>
	        );
		}else{
			return(<div></div>)
		}
        
    }

}

const mapStateTopProps = (state) => {
	let {memberList}=state.questionManage.imageCorrection
    return {    
        user:state.user,
        memberList:memberList
        
    };
}
const mapDispatchToProps = dispatch => {
    return {
        getMemberList: () => {
            dispatch(action.getMemberList());
        },
    }
};

export default connect(mapStateTopProps,mapDispatchToProps)(ImageCorrectionList);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/image_correction/image_correction_list.js